import React, { useCallback, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import StatusCard from "../components/status-card/StatusCard";
import { Grid, IconButton, Skeleton } from "@mui/material";
import { HiUser, HiUserGroup } from "react-icons/hi";
import config from "../api/config";

import DatePickerTG from "../components/DatePickerTG";
import StatusCardDetailed from "../components/status-card/StatusCardCustom";
import CustomSelect from "../components/select";

// const fetcher = (api, ) => {
//    config.get(`/api/statistics/v1/getAllClickAndSee`).then((data) => {
//      setLoad(false);
//      setStats(data.data.objectKoinot);
//    });
// }

const Dashboard = () => {
  // loadings
  const [load, setLoad] = useState(false);
  // error(
  const [error, setError] = useState(false);
  // count
  const [count, setCount] = useState(null);
  // stats
  const [stats, setStats] = useState(null);
  // dates
  const [fromf, setFromf] = useState(
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );
  const [tof, setfTof] = useState(new Date());
  // subscribers' stats
  const [fromJoin, setFromJoin] = useState(
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );
  const [toJoin, setToJoin] = useState(new Date());

  // click and see
  const [fromcs, setFromcs] = useState(new Date("2020-01-01"));
  const [tocs, setfTocs] = useState(new Date());
  //charts
  const [charts, setCharts] = useState([]);
  const [chartsCS, setChartsCS] = useState([]);
  const [totals, setTotals] = useState([]);
  const [dailyJoinings, setDailyJoinings] = useState([]);
  const [dailiJoiningTotals, setDailiJoiningTotal] = useState([]);

  const [role, setRole] = useState("user");
  const roles = [
    { name: "Бот", val: "user" },
    { name: "Группы", val: "group" },
  ];

  //

  const getFeatures = useCallback(() => {
    let from = fromf.toISOString().split("T")[0];
    let till = tof.toISOString().split("T")[0];

    setLoad(true);
    config
      .get(`/api/statistics/v1/getFeatures?from=${from}&till=${till}`)
      .then((data) => {

        setTotals(
          data.data.objectKoinot.map((v, i) => ({
            name: v.featureName,
            total: v.statistics.reduce(
              (accumulator, object) => accumulator + object.count,
              0
            ),
          }))
        );

        let cht = [
          {
            options: {
              tooltip: {
                theme: "dark",
              },
              chart: {
                id: "features",
                type: "column",
                minHeight: "400px",
              },
              title: {
                text: "Features",
                style: {
                  fontSize: "20px",
                  color: "var(--second-color)",
                },
              },
              grid: {
                row: {
                  colors: ["var(--main-color)"],
                  opacity: 1,
                },
                padding: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                },
              },
            },
            series: data.data.objectKoinot.map((v, i) => ({
              name: v.featureName,
              data: v.statistics.map((v) => ({
                x: v.day,
                y: v.count,
              })),
            })),
          },
        ];
        setLoad(false);
        setCharts(cht);
      })
      .catch((err) => setError(true));
  }, [fromf, tof]);

  // join - leave

  const getJoinerStats = useCallback(() => {
    let from = fromJoin.toISOString().split("T")[0];
    let till = toJoin.toISOString().split("T")[0];
    setLoad(true);
    config
      .get(
        `/api/statistics/v1/${role}/stats?from=${from}&till=${till}&active=true`
      )
      .then((data) => {
        setDailiJoiningTotal(
          data.data.objectKoinot.map((v, i) => ({
            name: v.featureName,
            total: v.statistics.reduce(
              (accumulator, object) => accumulator + object.count,
              0
            ),
          }))
        );

        // const bachalar = [
        //   {
        //     name: "Junior",
        //     data: [
        //       ["2021-01-02", 4],
        //       ["2021-01-06", 1],
        //       ["2021-01-08", 1],
        //     ],
        //   },
        //   {
        //     name: "Adult",
        //     data: [
        //       ["2021-01-02", 6],
        //       ["2021-01-05", 1],
        //       ["2021-01-06", 9],
        //       ["2021-01-07", 1],
        //     ],
        //   },
        //   { name: "Playing", data: [["2021-01-06", 1]] },
        // ];

        // const allMonth = [
        //   ...new Set(
        //     datas.flatMap((o) => o.statistics.map(([day]) => day))
        //   ),
        // ];

        // const result = data.map((o) => ({
        //   ...o,
        //   statistics: allMonth.map((i) => [
        //     i,
        //     Object.fromEntries(o.day)[i] || 0,
        //   ]),
        // }));
        // console.log(result);
        let cht = [
          {
            options: {
              tooltip: {
                theme: "dark",
              },
              chart: {
                id: "statistics",
                type: "column",
                minHeight: "400px",
              },
              title: {
                text: "Statistics of Joining",
                style: {
                  fontSize: "20px",
                  color: "var(--second-color)",
                },
              },
              grid: {
                row: {
                  colors: ["var(--main-color)"],
                  opacity: 1,
                },
                padding: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                },
              },
            },
            series: data.data.objectKoinot.map((v, i) => ({
              name: v.featureName,

              color: v.featureName === "JOIN" ? "#00FF00" : "#255aee",
              data: v.statistics.map((v) => ({
                x: v.day,
                y: v.count,
              })),
            })),
          },
        ];

        setLoad(false);
        setDailyJoinings(cht);
      })
      .catch((err) => setError(true));
  }, [fromJoin, toJoin, role]);
  const roleHandler = (index) => {
    setRole(index);
    // setLoading(true);
    // getJoinerStats(index);
  };
  //
  const getClickAndSee = useCallback(() => {
    let from = fromcs.toISOString().split("T")[0];
    let till = tocs.toISOString().split("T")[0];
    config
      .get(`/api/statistics/v1/getDaily?from=${from}&till=${till}`)
      .then((data) => {
        setLoad(false);

        let chtcs = [
          {
            options: {
              tooltip: {
                theme: "dark",
              },

              grid: {
                row: {
                  colors: ["var(--main-color)"],
                  opacity: 1,
                },
              },
              title: {
                text: "Adversitisement",
                style: {
                  fontSize: "20px",
                  color: "var(--second-color)",
                },
              },
              chart: {
                id: "ad",
              },
              xaxis: {
                categories: data.data.objectKoinot.map((v, i) => v.stringDate),
              },
            },
            series: [
              {
                type: "line",
                name: "Просмотры",
                data: data.data.objectKoinot.map((v, i) => v.see),
              },
              {
                type: "column",
                name: "Клики",
                data: data.data.objectKoinot.map((v, i) => v.click),
              },
            ],
          },
        ];
        setChartsCS(chtcs);
      });
  }, [fromcs, tocs]);

  useEffect(() => {
    setLoad(true);
    config.get(`/api/statistics/v1/getAllClickAndSee`).then((data) => {
      setStats(data.data.objectKoinot);
    });

    config.get(`/api/statistics/v1/getCount`).then((data) => {
      setCount(data.data.objectKoinot);
    });
  }, []);
  useEffect(() => { getJoinerStats(); }, [getJoinerStats]);
  useEffect(() => { getFeatures(); }, [getFeatures]);
  useEffect(() => { getClickAndSee(); }, [getClickAndSee]);

  return (
    <div>
      <h2 className="page-header">Dashboard</h2>
      <Grid>
        <Grid>
          <div className="row w-100 mb-5 g-5">
            {count && (
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="total-card">
                  <IconButton aria-label="delete" disabled>
                    <HiUser />
                  </IconButton>
                  <p className="display-4 fw-bold m-0">
                    {count?.userCount.toLocaleString()}
                  </p>
                  <br />
                  Все пользователи
                </div>
              </div>
            )}
            {count && (
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="total-card">
                  <IconButton aria-label="delete" disabled>
                    <HiUserGroup />
                  </IconButton>
                  <p className="display-4 fw-bold m-0">
                    {count?.countGroup.toLocaleString()}
                  </p>
                  <br />
                  Все группы
                </div>
              </div>
            )}
          </div>

          <div className="row align-items-center mb-5">
            {stats ? (
              <div className="row g-4">
                <div className="col-lg-3 col-sm-6 col-md-6">
                  <StatusCard
                    style={{ backgroundColor: "var(--third-color-blue)" }}
                    count={stats.monthlySee}
                    title={"Просмотров в месяц"}
                  />
                </div>
                <div className="col-lg-3 col-sm-6 col-md-6">
                  <StatusCard
                    style={{ backgroundColor: "var(--third-color-blue)" }}
                    count={stats.overallSee}
                    title={"Общие просмотры"}
                  />
                </div>
                <div className="col-lg-3 col-sm-6 col-md-6">
                  <StatusCard
                    style={{ backgroundColor: "var(--third-color-blue)" }}
                    count={stats.monthlyClick}
                    title={"Клики в месяц"}
                  />
                </div>
                <div className="col-lg-3 col-sm-6 col-md-6">
                  <StatusCard
                    style={{ backgroundColor: "var(--third-color-blue)" }}
                    count={stats.overallClick}
                    title={"Общее количество кликов"}
                  />
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-3 col-sm-6">
                  <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={118}
                    animation="wave"
                  />
                </div>
                <div className="col-md-3 col-sm-6">
                  <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={118}
                    animation="wave"
                  />
                </div>
                <div className="col-md-3 col-sm-6">
                  <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={118}
                    animation="wave"
                  />
                </div>
                <div className="col-md-3 col-sm-6">
                  <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={118}
                    animation="wave"
                  />
                </div>
              </div>
            )}

            {/* <div className="col-3">
              <div className="status-card" style={{ height: "100px" }}>
                <div className="status-card__info">
                  <CustomSelect
                    selVal={date}
                    selItems={selectValues}
                    selHandle={(e) => {
                      setDate(e);
                      console.log(e);
                    }}
                  />
                </div>
              </div>
            </div> */}
          </div>
        </Grid>
        <DatePickerTG
          from={fromf}
          to={tof}
          setFrom={(e) => setFromf(e)}
          setTo={(e) => setfTof(e)}
          submitHandle={getFeatures}
        />
        <div className="row w-100 align-items-center mb-4">
          {!error && charts.length > 0 ? (
            <>
              {charts.map((v, i) => (
                <div className="col-md-8 col-sm-12" key={i}>
                  <Chart
                    options={v.options}
                    series={v.series}
                    type={v.type}
                    className={"mb-4"}
                  />
                </div>
              ))}
              <div className="col-md-4 col-sm-12">
                <StatusCardDetailed
                  style={{ backgroundColor: "var(--third-color-blue)" }}
                  data={totals}
                />
              </div>
            </>
          ) : (
            load && (
              <div className="col-md-6">
                <Skeleton
                  variant="rectangular"
                  width={"100%"}
                  height={118}
                  animation="wave"
                />
              </div>
            )
          )}
        </div>

        {/* <----------------------> -- joins with leaves <-------------------------> */}
        <DatePickerTG
          from={fromJoin}
          to={toJoin}
          setFrom={(e) => setFromJoin(e)}
          setTo={(e) => setToJoin(e)}
          addition={
            <CustomSelect
              selVal={role}
              selItems={roles}
              type={"outlined"}
              label={"label"}
              selHandle={(e) => {
                roleHandler(e);
              }}
            />
          }
          submitHandle={getJoinerStats}
        />

        <div className="row w-100 align-items-center mb-4">
          {!error && dailyJoinings.length > 0 ? (
            <>
              {dailyJoinings.map((v, i) => (
                <div className="col-md-8 col-sm-12" key={i}>
                  <Chart
                    options={v.options}
                    series={v.series}
                    type={v.type}
                    className={"mb-4"}
                  />
                </div>
              ))}
              <div className="col-md-4 col-sm-12">
                <StatusCardDetailed
                  style={{ backgroundColor: "var(--third-color-blue)" }}
                  data={dailiJoiningTotals}
                />
              </div>
            </>
          ) : (
            load && (
              <div className="col-md-6">
                <Skeleton
                  variant="rectangular"
                  width={"100%"}
                  height={118}
                  animation="wave"
                />
              </div>
            )
          )}
        </div>

        <DatePickerTG
          from={fromcs}
          to={tocs}
          setFrom={(e) => setFromcs(e)}
          setTo={(e) => setfTocs(e)}
          submitHandle={getClickAndSee}
        />
        <Grid container>
          {!error && charts.length > 0 ? (
            <>
              {chartsCS.map((v, i) => (
                <Grid mb={5} xs={6} item key={i}>
                  <Chart
                    options={v.options}
                    series={v.series}
                    type={v.type}
                    className={"mb-4"}
                  />
                </Grid>
              ))}
            </>
          ) : (
            load && (
              <div className="col-md-6">
                <Skeleton
                  variant="rectangular"
                  width={"100%"}
                  height={118}
                  animation="wave"
                />
              </div>
            )
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;

// const defCharts = [
//   {
//     type: "bar",

//     options: {
//       tooltip: {
//         theme: "dark",
//       },
//       chart: {
//         id: "basic-bar",
//       },
//       xaxis: {
//         categories: data.data.objectKoinot.map((v, i) => v.stringDate),
//       },
//     },
//     toolbar: {
//       autoSelected: "pan",
//       show: false,
//     },
//     series: [
//       {
//         name: "Просмотры",
//         data: data.data.objectKoinot.map((v, i) => v.see),
//       },
//     ],
//   },
//   {
//     type: "area",
//     data: [
//       {
//         stroke: {
//           curve: "smooth",
//         },
//         options: {
//           tooltip: {
//             theme: "dark",
//           },
//           chart: {
//             id: "basic-bar",
//           },
//           xaxis: {
//             categories: data.data.objectKoinot.map((v, i) => v.stringDate),
//           },
//         },
//         series: [
//           {
//             name: "Клики",
//             data: data.data.objectKoinot.map((v, i) => v.click),
//           },
//         ],
//       },
//     ],
//   },
// ];
